import React, { useState } from 'react'
import StepOptions from '../header/StepOptions'
import StepIndicatorItem from './StepIndicatorItem'


const StepIndicator = (props) => {

   const [openOptions, setOpenOptions] = useState()


   const {
      currentStepIndex,
      openOptionsOnClick,
      listData,
      validateCurrentOptionForm,
      formState,
      setFormState,
      setListData,
      setCurrentStepIndex,
      basketState,
      setBasketState,
      handleOnslid
   } = props


   const handleClick = (evt, idx) => {
      validateCurrentOptionForm()
      setCurrentStepIndex(idx)
      if (openOptionsOnClick) {
         setOpenOptions(true)
      }
   }

   const items = listData.map(({ name, icon, wasValidated, isValid }, idx) => {
      return <StepIndicatorItem
         key={name}
         name={name}
         idx={idx}
         handleClick={handleClick}
         currentStepIndex={currentStepIndex}
         showValidationResult={wasValidated}
         isValid={isValid}
         setOpenOptions={setOpenOptions}
         openOptionsOnClick={openOptionsOnClick}
      />
   })


   return (
      <>
         <ul className='d-flex align-items-end px-1 pt-1 m-0 bg-white'>
            {items}
         </ul>
         <StepOptions
            openOptions={openOptions}
            setOpenOptions={setOpenOptions}
            setFormState={setFormState}
            formState={formState}
            validateCurrentOptionForm={validateCurrentOptionForm}
            setListData={setListData}
            listData={listData}
            currentStepIndex={currentStepIndex}
            setCurrentStepIndex={setCurrentStepIndex}
            basketState={basketState}
            setBasketState={setBasketState}
            handleOnslid={handleOnslid}
         />
      </>
   )
}
export default StepIndicator